import { MsalAuthenticationTemplate } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import { InteractionType } from "@azure/msal-browser";
import { ClientSelector } from "../../components/core/ClientSelector/ClientSelector";
import { useContext, useState } from "react";
import { DependencyInjectionContext } from "../../contexts/dependency-injection-context";
import { User } from "../../common";
import { Button } from "@mui/material";
import UserList from "./UserList/UserList";
import UserDetailsModal from "./UserDetails/UserDetailsModal";
import { EDIT, UserListEvent } from "./UserList/user-list-events";
import { LoadingIndicator } from "../../components/core/LoadingIndicator/LoadingIndicator";

export const Users = (props: any) => {

    const authRequest = {
        ...loginRequest
    };

    const [loading, setLoading] = useState<boolean>(false);
    const [users, setUsers] = useState<User[]>();
    const [selectedUser, setSelectedUser] = useState<User>({ id: null, clientId: null, roles: [], username: "" });
    const [selectedClientId, setSelectedClientId] = useState<string>();
    const [detailsOpen, setDetailsOpen] = useState<boolean>(false);

    const { formsApi } = useContext(DependencyInjectionContext);

    const getUsers = async (clientId: string | null = null) => {
        setLoading(true);

        let url = 'Users';
        if (clientId != null) {
            url += `?clientId=${clientId}`
        }

        const users = await formsApi.get<User[]>(url);
        setUsers(users);
        setLoading(false);
    };

    const onClientSelected = async (clientId: string) => {
        setSelectedClientId(clientId);
        getUsers(clientId);
    };

    function getNewUser(): User {
        return { id: null, clientId: selectedClientId ?? null, roles: [], username: "" };
    }

    const listActionClick = async (event: UserListEvent, user: User, clientId: string | undefined) => {
        switch (event) {
            case EDIT:
                setSelectedUser(user);
                setDetailsOpen(true);
                break;
            default:
                alert(`${event} is not implemented!`);
                break;
        }
    }

    return (
        <MsalAuthenticationTemplate
            interactionType={InteractionType.Redirect}
            authenticationRequest={authRequest}
        >
            <div className="page">
                <h1>Users</h1>
                <ClientSelector onClientSelected={onClientSelected}></ClientSelector>
                <div style={{ paddingBottom: '10px', marginTop: '50px' }}>
                        <Button variant="contained" onClick={() => {
                            setSelectedUser(getNewUser());
                            setDetailsOpen(true);
                        }}>Create new user</Button>
                    </div>
                <UserList users={users} clientId={selectedClientId} callback={listActionClick}></UserList>
            </div>

            <UserDetailsModal user={selectedUser} isOpen={detailsOpen} close={() => setDetailsOpen(false)} save={async (user) => {
                const updatedUser = await formsApi.post<User, User>("/UpdateUser", user);
            }}></UserDetailsModal>

            <LoadingIndicator loading={loading}></LoadingIndicator>
        </MsalAuthenticationTemplate>
    );
};

